import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "UpEmplacementModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "UpEmplacementModalRef"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-12 col-12 col-sm-12" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "col-md-6 col-sm-12" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "col-md-6 col-sm-12" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "col-md-6 col-sm-12" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "col-md-6 col-sm-12" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "col-md-6 col-xl-6 col-xm-12" }
const _hoisted_17 = {
  for: "contrat",
  class: "form-label fw-medium text-black"
}
const _hoisted_18 = { class: "col-md-6 col-xl-6 col-xm-12" }
const _hoisted_19 = {
  for: "contrat",
  class: "form-label fw-medium text-black"
}
const _hoisted_20 = { class: "col-md-6 col-sm-12" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "col-md-6 col-sm-12" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "col-md-6 col-sm-12" }
const _hoisted_25 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_AddUsagerModal = _resolveComponent("AddUsagerModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[27] || (_cache[27] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Emplacement"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Form, {
              ref: "usagerForm",
              onSubmit: _ctx.soumettre,
              "validation-schema": _ctx.usagerSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[12] || (_cache[12] = _createElementVNode("label", {
                        for: "parent",
                        class: "form-label fw-medium text-black"
                      }, " Emplacement Parent ", -1)),
                      _createVNode(_component_Field, {
                        name: "parent",
                        modelValue: _ctx.parent,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.parent) = $event)),
                        class: "form-control shadow-none fs-md-15 text-black"
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, {
                            "filter-results": false,
                            "min-chars": 2,
                            "resolve-on-load": false,
                            delay: 0,
                            searchable: true,
                            "options-limit": 300,
                            options: async (query) => {
                        if (query.length >= 3) {
                          const results = await _ctx.reupererContrat(query);
                          if (results && results.length > 0) {
                            return results;
                          } else {
                            return [
                              { value: '', label: 'Aucun enregistrement trouvé' },
                            ];
                          }
                        } else {
                          return [];
                        }
                      }
                        ,
                            noOptionsText: "Tapez au moins deux caractères",
                            placeholder: "Rechercher un contrat"
                          }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "parent",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                        _createTextVNode(" Ancien code "),
                        _createElementVNode("span", { class: "text-danger" })
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "emplacement",
                        modelValue: _ctx.emplacement,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.emplacement) = $event)),
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Renseigner le nom"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "emplacement",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                        _createTextVNode(" Nouveau code "),
                        _createElementVNode("span", { class: "text-danger" })
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "ncode",
                        type: "text",
                        modelValue: _ctx.ncode,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ncode) = $event)),
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Nouveau code"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "ncode",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                        _createTextVNode(" Taxe mensuelle "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "taux",
                        modelValue: _ctx.taux,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.taux) = $event)),
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Taux"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "taux",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[16] || (_cache[16] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, " Secteur ", -1)),
                      _createVNode(_component_Field, {
                        name: "secteur",
                        modelValue: _ctx.secteur,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.secteur) = $event))
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            options: _ctx.secteurs,
                            searchable: true,
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, { placeholder: "Sélectionner un secteur" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "secteur",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", _hoisted_17, [
                      _cache[19] || (_cache[19] = _createElementVNode("span", null, [
                        _createTextVNode(" Locataire "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("span", null, [
                        _createElementVNode("a", {
                          href: "#",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#AddUsagerModal",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.ajouterUsager && _ctx.ajouterUsager(...args))),
                          type: "button"
                        }, [...(_cache[17] || (_cache[17] = [
                          _createElementVNode("span", {
                            class: "badge text-bg-success",
                            style: {"margin-left":"0.3em"}
                          }, "A", -1)
                        ]))]),
                        _createElementVNode("a", {
                          href: "#",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#AddUsagerModal",
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.modifUsager && _ctx.modifUsager(...args))),
                          type: "button"
                        }, [...(_cache[18] || (_cache[18] = [
                          _createElementVNode("span", {
                            class: "badge text-bg-secondary ml-5",
                            style: {"margin-left":"0.3em"}
                          }, "M", -1)
                        ]))])
                      ])
                    ]),
                    _createVNode(_component_Field, {
                      name: "locataire",
                      modelValue: _ctx.locataire,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.locataire) = $event)),
                      class: "form-control shadow-none fs-md-15 text-black"
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          "model-value": field.value
                        }, field, {
                          "filter-results": true,
                          "min-chars": 3,
                          "resolve-on-load": false,
                          delay: 0,
                          searchable: true,
                          "options-limit": 300,
                          options: async (query) => {
                      if (query && query.length >= 3) {
                        const results = await _ctx.reupererUsagers(query);
                        if (results && results.length > 0) {
                          return results;
                        } else if (results.length >= 3) {
                          return [
                            {
                              value: '',
                              label: 'Aucun enregistrement trouvé',
                            },
                          ];
                        } else {
                          return [];
                        }
                      }
                    },
                          noOptionsText: "Tapez au moins deux caractères",
                          placeholder: "Rechercher un locataire"
                        }), null, 16, ["model-value", "options"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "locataire",
                      class: "text-danger"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("label", _hoisted_19, [
                      _cache[22] || (_cache[22] = _createElementVNode("span", null, [
                        _createTextVNode(" Exploitant "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("span", null, [
                        _createElementVNode("a", {
                          href: "#",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#AddUsagerModal",
                          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.ajouterUsager1 && _ctx.ajouterUsager1(...args))),
                          type: "button"
                        }, [...(_cache[20] || (_cache[20] = [
                          _createElementVNode("span", {
                            class: "badge text-bg-success",
                            style: {"margin-left":"0.3em"}
                          }, "A", -1)
                        ]))]),
                        _createElementVNode("a", {
                          href: "#",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#AddUsagerModal",
                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.modifUsager1 && _ctx.modifUsager1(...args))),
                          type: "button"
                        }, [...(_cache[21] || (_cache[21] = [
                          _createElementVNode("span", {
                            class: "badge text-bg-secondary ml-5",
                            style: {"margin-left":"0.3em"}
                          }, "M", -1)
                        ]))])
                      ])
                    ]),
                    _createVNode(_component_Field, {
                      name: "exploitant",
                      modelValue: _ctx.exploitant,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.exploitant) = $event)),
                      class: "form-control shadow-none fs-md-15 text-black"
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          "model-value": field.value
                        }, field, {
                          "filter-results": false,
                          "min-chars": 3,
                          "resolve-on-load": false,
                          delay: 0,
                          searchable: true,
                          "options-limit": 300,
                          options: async (query) => {
                      if (query && query.length >= 3) {
                        const results = await _ctx.reupererUsagers(query);
                        if (results && results.length > 0) {
                          return results;
                        } else if (results.length >= 3) {
                          return [
                            {
                              value: '',
                              label: 'Aucun enregistrement trouvé',
                            },
                          ];
                        } else {
                          return [];
                        }
                      }
                    },
                          noOptionsText: "Tapez au moins deux caractères",
                          placeholder: "Rechercher un exploitant"
                        }), null, 16, ["model-value", "options"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "exploitant",
                      class: "text-danger"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _cache[23] || (_cache[23] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, [
                        _createTextVNode(" Type emplacement "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_component_Field, { name: "typeEmplacement" }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            options: _ctx.types,
                            searchable: true,
                            "model-value": field.value,
                            "onUpdate:modelValue": field.onChange
                          }, field, { placeholder: "Sélectionner un type emplacement" }), null, 16, ["options", "model-value", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "typeEmplacement",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _cache[24] || (_cache[24] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, [
                        _createTextVNode(" Activite"),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_component_Field, { name: "activite" }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            options: _ctx.activites,
                            searchable: true,
                            "model-value": field.value,
                            "onUpdate:modelValue": field.onChange
                          }, field, { placeholder: "Sélectionner une activité" }), null, 16, ["options", "model-value", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "activite",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _cache[25] || (_cache[25] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                        _createTextVNode(" Plus detail activité "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_component_Field, {
                        name: "nouveau_activite",
                        modelValue: _ctx.nouveau_activite,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.nouveau_activite) = $event)),
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Tomate"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "nouveau_activite",
                        class: "text-danger"
                      })
                    ])
                  ])
                ]),
                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "row mt-5" }, [
                  _createElementVNode("div", { class: "col-md-3 text-md-end text-xl-end text-sm-center col-sm-12" }, [
                    _createElementVNode("button", {
                      type: "submit",
                      class: "btn btn-primary w-100"
                    }, " Enregistrer ")
                  ])
                ], -1))
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ]),
          _cache[28] || (_cache[28] = _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Fermer ")
          ], -1))
        ])
      ])
    ], 512),
    _createVNode(_component_AddUsagerModal, {
      item: _ctx.selectedItem,
      onClose: _ctx.recharger,
      onOpen: _ctx.show_Modal
    }, null, 8, ["item", "onClose", "onOpen"])
  ], 64))
}